import { DisclosureBaseFeature } from './disclosure-base.feature';

//used to access disclosures via url - using vivli id
export const DisclosureFromUrlFeature = () => {
    return <DisclosureBaseFeature withVivliId={true} />;
};
